export default __webpack_public_path__ + "static/media/lotusmoon.c3959ff4.jpg";